import {useEffect, useState} from 'react';
import {useMsal} from '@azure/msal-react';
import {apiRequest} from '../authConfig';
import {SilentRequest} from '@azure/msal-browser';

export const useToken = () => {
  const [isTokenReady, setIsTokenReady] = useState(false);
  const [tokenError, setTokenError] = useState<string | null>(null);
  const {accounts, instance} = useMsal();

  useEffect(() => {
    const initializeToken = async () => {
      try {
        if (accounts.length > 0) {
          console.log('Acquiring access token for API calls...');

          const account = accounts[0];

          // Try to get token silently first
          const silentRequest: SilentRequest = {
            scopes: apiRequest.scopes,
            account: account,
          };

          try {
            const response = await instance.acquireTokenSilent(silentRequest);
            // Store token in sessionStorage
            sessionStorage.setItem('oauth_access_token', response.accessToken);
            console.log('Access token acquired successfully');
            setIsTokenReady(true);
          } catch (silentError) {
            console.warn(
              'Silent token acquisition failed, trying interactive method',
              silentError
            );

            // If silent acquisition fails, try interactive
            try {
              const response = await instance.acquireTokenPopup(apiRequest);
              sessionStorage.setItem(
                'oauth_access_token',
                response.accessToken
              );
              console.log('Access token acquired successfully via popup');
              setIsTokenReady(true);
            } catch (popupError) {
              console.error('Popup token acquisition failed:', popupError);
              setTokenError('Failed to acquire access token');
            }
          }
        }
      } catch (error) {
        console.error('Error initializing token:', error);
        setTokenError('Error initializing authentication token');
      }
    };

    initializeToken();
  }, [accounts, instance]);

  return {isTokenReady, tokenError};
};

export default useToken;
